import { forwardRef } from 'react'
import HeroIcon, { HeroIconProps } from '../HeroIcon'

export default forwardRef<SVGSVGElement, HeroIconProps>((props, ref) => {
  const { type = 'solid', ...rest } = props
  return <HeroIcon ref={ref} Component={Component} {...rest} />
})

const Component = forwardRef<SVGSVGElement, any>((props, ref) => {
  return (
    <svg ref={ref} width="24" height="24" viewBox="0 0 44 34" fill="none" {...props}>
      <path
        d="M16 1.10156C18.1217 1.10156 20.1566 1.94442 21.6569 3.44471C23.1571 4.945 24 6.97983 24 9.10156C24 11.2233 23.1571 13.2581 21.6569 14.7584C20.1566 16.2587 18.1217 17.1016 16 17.1016C13.8783 17.1016 11.8434 16.2587 10.3431 14.7584C8.84285 13.2581 8 11.2233 8 9.10156C8 6.97983 8.84285 4.945 10.3431 3.44471C11.8434 1.94442 13.8783 1.10156 16 1.10156ZM22.0063 20.1016C22.15 24.7703 24.3 30.0078 28.6313 33.1016H2L6 20.1016H22.0063Z"
        fill="#181818"
      />
      <path
        d="M39.9562 19.7262L34 17.4199V28.9762C37.5312 27.3324 39.6375 23.5387 39.9562 19.7262ZM34 32.2012C28 30.2012 25 24.0637 25 18.7012V17.6887L34 14.2012L43 17.6887V18.7012C43 24.0637 40 30.2012 34 32.2012Z"
        fill="#181818"
      />
    </svg>
  )
})
